import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PolicyInfoService } from './policyinfo.service';
import { ConfigService } from './config.service';
import { PolicyInfo, Config } from './app.models';
import { PolicyUpdateService } from './policyupdate.service';
import * as validation from './validation.service';

@Component({
  selector: 'app-apply-div',
  templateUrl: './app.applycomponent.html',
  styleUrls: ['./app.applycomponent.scss']
})
export class ApplyComponent implements OnInit {
  constructor(private route: ActivatedRoute, private render: Renderer2, private policyInfoSvc: PolicyInfoService,
              private configSvc: ConfigService, private policyUpdateSvc: PolicyUpdateService) { }
  policyInfo: PolicyInfo;
  config: Config;
  carrierLogo: string;
  phone: string;
  showSelectedPolicyContainer: boolean;
  ngOnInit() {
    this.configSvc.getPolicyInfoConfig()
      .subscribe(config => {
        this.carrierLogo = this.decodeCarrierLogo(this.route.snapshot.queryParams['carrier-logo']);
        const hash = this.route.snapshot.queryParams.policyid;
        this.getPolicyData(hash, config.QueryServerUrl);
        this.config = config;
      });
  }
  onEditBtnClick() {
    this.render.addClass(document.getElementById('apply-edit-btn'), 'hidden');
    this.render.addClass(document.getElementById('apply-info'), 'hidden');
    this.render.addClass(document.getElementById('edit-btns'), 'edit-apply-info-offset');
    this.render.removeClass(document.getElementById('apply-confirm-btn'), 'hidden');
    this.render.removeClass(document.getElementById('apply-confirm-btn-bottom'), 'hidden');
    this.render.removeClass(document.getElementById('apply-edit-form'), 'hidden');
  }
  onConfirmBtnClick() {
    const valid = this.validateFormBox();
    if (valid) {
      this.render.addClass(document.getElementById('apply-confirm-btn'), 'hidden');
      this.render.addClass(document.getElementById('apply-confirm-btn-bottom'), 'hidden');
      this.render.addClass(document.getElementById('apply-edit-form'), 'hidden');
      this.render.removeClass(document.getElementById('edit-btns'), 'edit-apply-info-offset');
      this.render.removeClass(document.getElementById('apply-edit-btn'), 'hidden');
      this.render.removeClass(document.getElementById('apply-info'), 'hidden');
      this.updatePolicyInfo();
    }
  }
  onSubmitBtnClick() {
    const formValid = this.validateFormBox();
    const emailValid = validation.validateEmailAddress();
    this.setValidationClass(emailValid, 'email');
    if (formValid && emailValid) {
      this.updatePolicyInfo();
      this.policyUpdateSvc.publishPolicyUpdate(this.policyInfo, this.config.PolicyUpdateUrl, this.route.snapshot.queryParams.policyid)
        .subscribe(() => {
          window.location.href = this.config.ThankYouUrl + this.route.snapshot.queryParams.source;
        });
    }
  }
  getPolicyData(policyHash: string, url: string) {
    this.policyInfoSvc.getPolicyInfo(policyHash, url)
      .subscribe((policyInfo: PolicyInfo) => {
        this.policyInfo = policyInfo;
        this.phone = policyInfo.PhoneNumber;
        this.showPolicyContainer(this.route.snapshot.queryParams['carrier-logo'], this.policyInfo);
      });
  }
  decodeCarrierLogo(carrierLogo: string): string {
    if (carrierLogo === undefined) {
      return '';
    }
    return atob(carrierLogo);
  }
  showPolicyContainer(carrierLogo: string, policyInfo: PolicyInfo) {
    if (carrierLogo !== undefined && policyInfo.MonthlyPremium !== undefined && policyInfo.CoverageLength !== undefined
      && policyInfo.FaceAmount !== undefined) {
      this.showSelectedPolicyContainer = true;
    } else {
      this.showSelectedPolicyContainer = false;
    }
  }
  updatePolicyInfo() {
    const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
    this.policyInfo.FirstName = firstNameInput.value;
    const middleInitialInput = document.getElementById('middleInitial') as HTMLInputElement;
    this.policyInfo.MiddleInitial = middleInitialInput.value;
    const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
    this.policyInfo.LastName = lastNameInput.value;
    const zipCodeInput = document.getElementById('zip') as HTMLInputElement;
    this.policyInfo.ZipCode = zipCodeInput.value;
    const phoneNumberInput = document.getElementById('phone') as HTMLInputElement;
    this.policyInfo.PhoneNumber = phoneNumberInput.value.replace(/[^a-zA-Z0-9]/g, '');
    const emailAddressInput = document.getElementById('email') as HTMLInputElement;
    this.policyInfo.EmailAddress = emailAddressInput.value;
  }
  validateFormBox() {
    const fNameValid = validation.validateName('firstName');
    this.setValidationClass(fNameValid, 'firstName');
    const lNameValid = validation.validateName('lastName');
    this.setValidationClass(lNameValid, 'lastName');
    const phoneValid = validation.validatePhoneNumber();
    this.setValidationClass(phoneValid, 'phone');
    const zipValid = validation.validateZip();
    this.setValidationClass(zipValid, 'zip');
    return fNameValid && lNameValid && phoneValid && zipValid;
  }
  setValidationClass(valid: boolean, elementId: string) {
    if (!valid) {
      this.render.addClass(document.getElementById(elementId), 'field-error');
    } else {
      this.render.removeClass(document.getElementById(elementId), 'field-error');
    }
  }
}
